<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'APP'
}
</script>

<style>
#app {
  box-sizing: border-box;
  height: 100%;
  background: #eff4f8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue